/* ============================================================
   impressed — luxury scroll motion
   Gentle parallax on the hero banner media. Apple-like:
   slow, subtle, respectful of reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var media = document.querySelector('.banner__media img');
  if (!media) return;
  var banner = media.closest('.banner') || media.parentElement;

  var ticking = false;
  function update() {
    ticking = false;
    var rect = banner.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    var offset = -rect.top;
    var shift = Math.max(-60, Math.min(60, offset * 0.12));
    media.style.transform = 'scale(1.12) translateY(' + shift.toFixed(1) + 'px)';
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
